import { Injectable } from '@angular/core';
import { getSystem } from '@utils/system';
import { LocalStorageService } from '@services/storage/local-storage.service';
import Swal from 'sweetalert2';
import { System } from '@models/System';
import { STORAGE_KEYS } from '@constants/StorageKeys';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  clientName = '';
  primaryColor = '';

  constructor(private storageService: LocalStorageService) {
    const system = this.getSystem() || {};
    if (system) {
      this.clientName = system.name;
      this.primaryColor = system.primaryColor;
    }
  }

  private getSystem(): System {
    return this.storageService.getObject(STORAGE_KEYS.SYSTEM);
  }

  updateClient(systemId: number) {
    const {name, primaryColor} = getSystem(systemId);
    this.clientName = name;
    this.primaryColor = primaryColor;
  }

  showWarning(text:string) {
    Swal.fire({
      title: this.clientName,
      text: text,
      position: 'center',
      icon: 'warning',
      showConfirmButton: true,
      confirmButtonColor: this.primaryColor,
    });
  }

  showInfo(text:string) {
    Swal.fire({
      title: this.clientName,
      text: text,
      icon: 'info',
      position: 'center',
      showConfirmButton: true,
      confirmButtonColor: this.primaryColor,
    });
  }

  showSmallInfo(text: string) {
    Swal.mixin({
      toast: true,
      position: 'top-right',
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    }).fire({
      icon: 'info',
      title: this.clientName,
      text: text,
      confirmButtonColor: this.primaryColor,
    });
  }

  showSuccess(text:string, timer = 1500) {
    Swal.fire({
      title: this.clientName,
      text: text,
      position: 'center',
      icon: 'success',
      showConfirmButton: true,
      confirmButtonColor: this.primaryColor,
      timer
    });
  }

  showSmallSuccess(text: string){
    Swal.mixin({
      toast: true,
      position: 'top-right',
      showConfirmButton: false,
      timer: 1800,
      timerProgressBar: true,
    }).fire({
      icon: 'success',
      title: this.clientName,
      text: text,
      confirmButtonColor: this.primaryColor,
    });
  }

  showError(message? : string) {
    Swal.fire({
      title: this.clientName,
      text: message || 'Error de servidor',
      position: 'center',
      icon: 'error',
      confirmButtonColor: this.primaryColor,
    });
  }

  showErrorForm(text: string = "Completa todos los campos correctamente") {
    Swal.fire({
      title: this.clientName,
      text,
      position: 'center',
      icon: 'error',
      confirmButtonColor: this.primaryColor,
    });
  }

  showSmallErrorServer(message? : string) {
    Swal.mixin({
      toast: true,
      position: 'top-right',
      showConfirmButton: false,
      timer: 1800,
      timerProgressBar: true,
    }).fire({
      icon: 'error',
      title: this.clientName,
      text: message || 'Error de servidor',
    });
  }

  async showConfirmationDeletion({ title = "¡Confirmación de eliminación! ", text = "¿Eliminar Registro?" } = {}) {
    const result = await Swal.fire({
      title,
      text,
      icon: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar',
      confirmButtonColor: this.primaryColor,
      reverseButtons: true,
    });

    return result.isConfirmed;
  }

  async showConfirmationAction({ title = "¡Confirmación! ", text = "¿Esta seguro que desea realizar esta acción?" } = {}) {
    const result = await Swal.fire({
      title,
      text,
      icon: 'question',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar',
      confirmButtonColor: this.primaryColor,
      reverseButtons: true,
    });

    return result.isConfirmed;
  }
}
